/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/** Unique tabs using H6 as an anchor **/

 // Equalize Heights Js
  var maxHeight = 0;
  $(".ProductItem__Info .ProductItem__Title").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".ProductItem__Info .ProductItem__Title").height(maxHeight);

  var maxHeight = 0;
  $(".prodcut_extra_info").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".prodcut_extra_info").height(maxHeight);


// STAYAI Updates
(function() {
  window.addEventListener('stay-ai-subscription-changed', () => {
    setTimeout(() => {
      const priceEl = document.querySelector('.Product__Info  .ProductForm__AddToCart .productForm__addToCart-price, .Product__Info  .ProductForm__AddToCart [data-money-convertible]');
      const stayOption = document.querySelector('.Product__Info .stayai-widget [name="purchaseType"]:checked');
      
      if (!priceEl || !stayOption) return
      const stayLabelWrapper = stayOption.closest('.stayai-purchase-label__wrapper');
      const stayPrice = stayLabelWrapper.querySelector('[data-stayai-onetime-price], [data-stayai-subscription-price')
      priceEl.innerHTML = stayPrice.innerHTML || priceEl.innerHTML
    }, 10);
  })
}())